<div class="content-heading">
  <div class="header-container">
    <h3>Producto</h3>
    <small>Detalle del Producto</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row">
            
            <div class="col-lg-3 col-md-12 col-sm-12 text-center">
              <label class="form-label">Código de barras</label>
              <div class="d-flex justify-content-center p-3 bg-light rounded">
                <ngx-barcode6 
                  [bc-format]="'CODE128'" 
                  [bc-value]="product.Codebar" 
                  [bc-display-value]="true"
                  [bc-width]="1.5"
                  [bc-height]="60">
                </ngx-barcode6>
              </div>
            </div>

            <div class="col-lg-9 col-md-12 col-sm-12">
              <div class="row">
                <div class="col-lg-6 col-md-6">
                  <aph-custom-text label="Producto" [(ngModel)]="product.ProductDescription" [disabled]="true"></aph-custom-text>
                </div>
                <div class="col-lg-6 col-md-6">
                  <aph-custom-text label="Nombre corto" [(ngModel)]="product.ProductName" [disabled]="true"></aph-custom-text>
                </div>
                
                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Planta ID" [(ngModel)]="product.ItemPlantaId" [disabled]="true"></aph-custom-text>
                </div>
                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Código" [(ngModel)]="product.ProductCode" [disabled]="true"></aph-custom-text>
                </div>
                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Tipo" [(ngModel)]="product.ProductType" [disabled]="true"></aph-custom-text>
                </div>

                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Precio" [(ngModel)]="product.ProductPrice" [disabled]="true"></aph-custom-text>
                </div>
                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Cupo" [(ngModel)]="product.ProductConversion" [disabled]="true"></aph-custom-text>
                </div>
                <div class="col-lg-4 col-md-4">
                  <aph-custom-text label="Peso" [(ngModel)]="product.ProductWeight" [disabled]="true"></aph-custom-text>
                </div>
              </div>
            </div>

          </div>

          <hr>

          <div class="row mt-3">
            <div class="col-12">
              <aph-custom-buttons 
                preset="exit" 
                label="Salir" 
                (btnClick)="btnCancelOnClick()">
              </aph-custom-buttons>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>